'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAvailable = undefined;

var _isAgentState = require('./isAgentState');

var _AgentStates = require('../../constants/AgentStates');

var isAvailable = exports.isAvailable = (0, _isAgentState.isAgentState)(_AgentStates.AVAILABLE);